// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


// export const environment = {             //dev.runloyal
//   production: true,
//   basePath: "https://dev.runloyal.com/services",
//   userService: "https://dev.runloyal.com/services/user-service",
//   notificationService: "https://dev.runloyal.com/services/notification-service",
//   calendarService: "https://dev.runloyal.com/services/calendar-service",
//   messageService: "https://dev.runloyal.com/services/message-service",
//   oauth2TokenEndPoint: "https://dev.runloyal.com/services/user-service/oauth/token",
//   // oauth2TokenEndPoint: "http://localhost:1443/services/user-service/oauth/token",
//   oauth2ClientId: "app_user",
//   oauth2Secret: "password",
//   oauth2Scope: "USER",
//   // tenantKey: "dogsrus",
//   // tenantKey: "paw-palace",
//   // tenantKey: "",
//   tenantKey: "suitepaws",
//   // tenantKey: "gooddogs",
//   // tenantKey: "barkandboarding",
//   // tenantKey: "nycpetdirect",
//   // tenantKey: "amopetcare",
//   // tenantKey: "dogspaw",
//   // tenantKey: "thehoundry",
//   // tenantKey: "pupncuts",
//   // tenantKey: "chevypawspetcare",
//   // tenantKey: "dogkingdom",
//    //tenantKey: "runloyalpetresort",
//   // tenantKey: "themuddymutt", 
//   // tenantKey: "fidofido-alpharetta",
//   applicationKey: "iTrust-PawOps",
//   version: "1.55",
//   paymentReturnUrl: "https://dev.runloyal.com/suitepaws/thankyou.html",
//   applicationReturnUrl:"https://dev.runloyal.com",
//   webPaymentReturnUrl: "https://" + "{tenantKey}"+ "-dev.runloyal.com/book/#/thankyou",
//   addCardReturnUrl: "https://uat.runloyal.com/suitepaws/thankyouAddCard.html",
//   reportCardUrl: "https://dev.runloyal.com/suitepaws/reportcard.html",

//   petTypeUrl : 'https://dev.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType',
//   petDetailUrl: 'https://dev.runloyal.com/services/user-service/pets/paw-palace/pets/{{userKey}}',
//   petBreadUrl : 'https://dev.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/breeds?pageNumber=0&size=1000',
//   petGenderUrl : 'https://dev.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/petGender',
//   agreementOneUrl:'https://dev.runloyal.com/services/user-service/',
//   agreementThreeUrl:'https://{tenantKey}-dev.runloyal.com/user-agreement/signature/upload'
// };



export const environment = {             //prod
  production: true,
  basePath: "https://www.runloyal.com/services",
  userService: "https://www.runloyal.com/services/user-service",
  notificationService: "https://www.runloyal.com/services/notification-service",
  calendarService: "https://www.runloyal.com/services/calendar-service",
  messageService: "https://www.runloyal.com/services/message-service",
  oauth2TokenEndPoint: "https://www.runloyal.com/services/user-service/oauth/token",
  // oauth2TokenEndPoint: "http://localhost:1443/services/user-service/oauth/token",
  oauth2ClientId: "app_user",
  oauth2Secret: "password",
  oauth2Scope: "USER",
   //tenantKey: "dogsrus",
   //tenantKey: "paw-palace",
  // tenantKey: "pawops-demo",
  // tenantKey: "suitepaws",
  // tenantKey: "amopetcare",
  // tenantKey: "pawsandpamper",
  // tenantKey: "gooddogs",
 // tenantKey: "barkandboarding",
    // tenantKey: "nycpetdirect",
  // tenantKey: "thehoundry",
  // tenantKey: "dogspaw",
    // tenantKey: "pupncuts",
   //tenantKey: "sitstay",
  // tenantKey: "dogkingdom",
  // tenantKey: "themuddymutt",
 // tenantKey: "weststreetdog",
 // tenantKey: "chevypaws",
  tenantKey: "runloyalpetresort",
  //tenantKey: "happytailslodge", 
  //tenantKey: "fidofido-alpharetta",
 // tenantKey: "opiesoutpost",
  //tenantKey: "preciouspaws",
  // tenantKey: "playfulpaws",
 //tenantKey: "atlantapetcarecenter",
 //tenantKey: "campknine",
//tenantKey: "citydogs",
 //tenantKey: "dejasdoggiecamp",
 // tenantKey : "pawpack",
 // tenantKey : "pupease",
 // tenantKey: "rangerdog",
 // tenantKey: "altamahacanine",
  // tenantKey: "campknine",
  // tenantKey: "campknine",
 //tenantKey: "dogdoggo",
//tenantKey: "peaceofmind",
 // tenantKey: "jesseyspups",
// tenantKey: "sipmafarms",
 //tenantKey: "animalhouse",
//tenantKey: "maximumk9service",
//  tenantKey: "cindylousdos",
  // tenantKey: "urbanwoof",
  // tenantKey: "mountaindog",
  //tenantKey: "yappypups",
  // tenantKey: "purrology",
//tenantKey: "brewcrews",
//tenantKey: "bethsbng",
//tenantKey: "brunosbath",
//tenantKey: "caninecuties",
//tenantKey: "dianesdog",
//tenantKey: "headtotail",
 //tenantKey: "doggiestyles",
//tenantKey: "standproud",
//tenantKey: "pawsandpints",
 //tenantKey:"peninsulapetlodge",
 //tenantKey:"fullcirclecanine",
 //tenantKey:"caninestateofmind",
 //tenantKey:"goodshepherd",
 //tenantKey:"baileysdaily",
  //tenantKey:"riverbanks",
//tenantKey:"rubysk9corral",
//tenantKey:"pawplex",
 //tenantKey:"pawsforeffect",
 //tenantKey:"wagnbone",
 //tenantKey:"woofiespal",
//tenantKey:"zendogs",
 //tenantKey:"canineranch",
//tenantKey:"luckydog",
//tenantKey:"doggiestyles-wedowee",
//tenantKey:"bluemoonpetboutique",
//tenantKey:"blackcreekboarding",
//tenantKey:"barkandsuds",
//tenantKey:"friendlyfurscapes",
//tenantKey:"chicagopetclub",
 //tenantKey:"wagspetretreat",
 // tenantKey:"southpaw",
// tenantKey:"dogboardingmarietta",
//tenantKey:"happypawspetlounge",
// tenantKey:"thedoghouseschool",
 //tenantKey:"hankspetlodge",
//tenantKey:"groomgoround",
 //tenantKey:"sundancepetgrooming",
 // tenantKey:"encoregrooming",
  // tenantKey:"thedelighteddog",
// tenantKey:"custompaws",
// tenantKey:"doggedlyfun",
// tenantKey:"dogdayzzz",
//tenantKey:"k9tailshakers",
//tenantKey:"diamondkennels",
//tenantKey:"gottalovethose",
//tenantKey:"scrubadubdoggie",
//tenantKey:"mightymuttzgrooming",
//tenantKey:"mkkennels",
//tenantKey:"luckypawspetspa",
//  tenantKey:"fursaflyin",
//tenantKey:"brooklynpaws",
//tenantKey:"luckydawgpet",
// tenantKey:"redbarninn",
 //tenantKey:"thepuppery",
 //tenantKey:"thespotteddog",
  // tenantKey:"bingsboarding",
  //tenantKey:"thepuppery",
  //tenantKey:"inthedoghouse",
  // tenantKey:"whiskerstowags",
 // tenantKey:"pawzawaypetcare",
  //tenantKey:"dogtalk",
//  tenantKey:"hollyridgemanorccc",
//  tenantKey:"letsgocanine",
  //tenantKey:"windmilllanekennel",
//tenantKey:"thedogcabinbb",
//tenantKey:"kninecountryclub",
//tenantKey:"champstrong",
//tenantKey:"muttsmansion",
//tenantKey:"caninecountryclub",
//tenantKey:"happygoluckydognj",
// tenantKey:"goosecreek",
//tenantKey:"imperialcanine",
//tenantKey: "customcanine",
//tenantKey: "lapdogmobile",
// tenantKey: "pupsandpints",
// tenantKey: "aaacuddlepups",
// tenantKey: "pinkdogspa",
// tenantKey: "wagsandwhiskers",
// tenantKey: "opportunitybarks",
// tenantKey: "pawsandtails",
//tenantKey: "thedogstead",
// tenantKey:"barkbarkcanineclub",
//tenantKey:"mindfulmutt",
  applicationKey: "iTrust-PawOps",
  version: "1.56",
  paymentReturnUrl: "https://www.runloyal.com/suitepaws/thankyou.html",
  webPaymentReturnUrl: "https://www." + "{tenantKey}" + ".runloyal.com/book/#/thankyou",
  applicationReturnUrl:"https://www.runloyal.com",
  addCardReturnUrl: "https://uat.runloyal.com/suitepaws/thankyouAddCard.html",
  reportCardUrl: "https://www.runloyal.com/suitepaws/reportCard.html",
  cardSavedUrl: "https://www.runloyal.com/suitepaws/cardSaved.html",


  //web specific
  petTypeUrl : 'https://www.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType',
  petDetailUrl: 'https://www.runloyal.com/services/user-service/pets/paw-palace/pets/{{userKey}}',
  petBreadUrl : 'https://www.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/breeds?pageNumber=0&size=1000',
  petGenderUrl : 'https://www.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/petGender',
  agreementOneUrl:'https://www.runloyal.com/services/user-service',
  agreementThreeUrl:'https://{tenantKey}.runloyal.com/user-agreement/signature/upload'
};

// export const environment = {            //uat.pawops
//   production: true,
//   basePath: "https://uat.runloyal.com/services",
//   applicationReturnUrl:"https://uat.runloyal.com",
//   // userService: "https://uat.runloyal.com/services/user-service",
//   userService: "https://uat.runloyal.com/services/user-service",
//   notificationService: "https://uat.runloyal.com/services/notification-service",
//   calendarService: "https://uat.runloyal.com/services/calendar-service",
//   messageService: "https://uat.runloyal.com/services/message-service",
//   oauth2TokenEndPoint: "https://uat.runloyal.com/services/user-service/oauth/token",
//   // oauth2TokenEndPoint: "http://localhost:1443/services/user-service/oauth/token",
//   oauth2ClientId: "app_user",
//   oauth2Secret: "password",
//   oauth2Scope: "USER",
//   // tenantKey: "dogsrus",
//     // tenantKey: "dogkingdom",
//   // tenantKey: "thehoundry",
//   // tenantKey: "paw-palace",
//   // tenantKey: "dogspaw",
//   //   tenantKey: "themuddymutt",
//   // tenantKey: "pupncuts",
//    tenantKey: "suitepaws",
//   // tenantKey: "runloyalpetresort",
//   //tenantKey:"sitstay",
//    //tenantKey:"pupncuts",
//   applicationKey: "iTrust-PawOps",
//   version: "1.56",
//   paymentReturnUrl: "https://uat.runloyal.com/suitepaws/thankyou.html",
//   webPaymentReturnUrl: "https://" + "{tenantKey}"+ "-uat.runloyal.com/book/#/thankyou",
//   reportCardUrl: "https://uat.runloyal.com/suitepaws/reportCard.html",
//   cardSavedUrl: "https://www.runloyal.com/suitepaws/cardSaved.html",
//   addCardReturnUrl: "https://uat.runloyal.com/suitepaws/thankyouAddCard.html",
//   petTypeUrl : 'https://uat.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType',
//   petDetailUrl: 'https://uat.runloyal.com/services/user-service/pets/paw-palace/pets/{{userKey}}',
//   petBreadUrl : 'https://uat.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/breeds?pageNumber=0&size=1000',
//   petGenderUrl : 'https://uat.runloyal.com/services/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/petGender',
//   agreementOneUrl:'https://uat.runloyal.com/services/user-service',
//   agreementThreeUrl:'https://{tenantKey}-uat.runloyal.com/user-agreement/signature/upload'
// };

/*
export const environment = {            //proxy
  production: false,
  basePath: "https://www.runloyal.com/jun23",
  userService: "https://www.runloyal.com/jun23/user-service",
  messageService: "https://dev.pawops.com/services/message-service",
    calendarService: "https://www.runloyal.com/jun23/calendar-service",
  notificationService: "https://dev.pawops.com/services/notification-service",
    oauth2TokenEndPoint: "https://www.runloyal.com/jun23/user-service/oauth/token",
  // oauth2TokenEndPoint: "http://localhost:1443/services/user-service/oauth/token",
  oauth2ClientId: "app_user",
  oauth2Secret: "password",
  oauth2Scope: "USER",
  tenantKey: "paw-palace",
  applicationKey: "iTrust-PawOps",

  petTypeUrl : 'https://www.runloyal.com/jun23/user-service/api/v2/paw-palace/TN03loC01/petType',
  petDetailUrl: 'https://www.runloyal.com/jun23/user-service/pets/paw-palace/pets/{{userKey}}',
  petBreadUrl : 'https://www.runloyal.com/jun23/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/breeds?pageNumber=0&size=1000',
  petGenderUrl : 'https://www.runloyal.com/jun23/user-service/api/v2/paw-palace/TN03loC01/petType/{{petTypeId}}/petGender'
};
*/
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
